import Vue from 'vue'

import facilitator from './services/facilitator'    // 代理商管理
import authentication from './services/authentication'  // 认证管理
import sellerinfo from './services/sellerInfo'      // 商户管理
import serviceprovider from './services/serviceprovider'    // 服务商管理
import paymentmanage from './services/paymentmanage'    // 支付管理
import refundadmin from './services/refundAdmin'    // 退款管理
import User from './services/user'    // 登录
import systemUser from './services/systemUser'    // 用户管理
import systemSettings from './services/systemSettings' //系统设置
import menuManagement from './services/menuManagement' //菜单管理
import webpage from "./services/webpage" //  网页版接口
import checkMark from './services/checkmark' // 注销
import statementAccount from "./services/statementAccount" // 对账单
import serviceConfig from "./services/serviceConfig" // 多服务商配置
import dataAnalysis from "./services/dataAnalysis" // 数据分析
import BookKeeping from "./services/bookKeeping" // 数据分析
import tableSetting from './services/tableSetting' // 表格设置
import taskManage from './services/taskManage' // 表格设置
import errorCode from './services/errorCode' // 错误码


Vue.prototype.service = {
  facilitator,
  authentication,
  sellerinfo,
  serviceprovider,
  paymentmanage,
  refundadmin,
  User,
  systemUser,
  systemSettings,
  menuManagement,
  webpage,
  checkMark,
  statementAccount,
  serviceConfig,
  dataAnalysis,
  BookKeeping,
  tableSetting,
  taskManage,
  errorCode,
}



// WEBPACK FOOTER //
// ./src/service/index.js